import React, { useEffect, useRef } from 'react';
import { View, Animated, Platform } from 'react-native';
import { Focusable, Text, Icon } from '..';
import { useStyleSheet, useThemeContext } from '../../hooks';
import { createStyleSheet } from '../../utils';
export function Switch({ onChange, value, header, after, before, disabled, icon }) {
    const styles = useStyleSheet(getStyles);
    const { color, size } = useThemeContext();
    const DotPosition = { off: size.B - 1, on: size.I };
    const DotWidth = { default: size.F, pressed: size.H };
    const mounted = useRef(false);
    const width = useRef(new Animated.Value(DotWidth.default)).current;
    const left = useRef(new Animated.Value(value ? DotPosition.on : DotPosition.off)).current;
    const onPressIn = () => {
        Animated.timing(width, {
            toValue: DotWidth.pressed,
            duration: 150,
            useNativeDriver: Platform.OS !== 'web'
        }).start();
        if (value) {
            Animated.timing(left, {
                toValue: DotPosition.on - size.B,
                duration: 150,
                useNativeDriver: Platform.OS !== 'web'
            }).start();
        }
    };
    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        Animated.timing(width, {
            toValue: DotWidth.default,
            duration: 150,
            useNativeDriver: Platform.OS !== 'web'
        }).start();
        Animated.timing(left, {
            toValue: !value ? DotPosition.off : DotPosition.on,
            duration: 150,
            useNativeDriver: Platform.OS !== 'web'
        }).start();
    }, [value]);
    return (React.createElement(View, null,
        header ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'semibold', style: [styles.header, before ? styles.header__start : null] }, header)) : null,
        React.createElement(View, { style: styles.wrapper },
            before ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.before }, before)) : null,
            React.createElement(Focusable, { style: styles.container, hoverStyle: {}, pressStyle: {}, disabled: disabled, onPress: () => {
                    if (disabled)
                        return;
                    onChange(!value);
                }, onPressIn: () => {
                    if (disabled)
                        return;
                    onPressIn();
                } }, ({ hovered }) => (React.createElement(Animated.View, { style: [
                    styles.main,
                    icon && styles.main__icon,
                    {
                        backgroundColor: left.interpolate({
                            inputRange: [DotPosition.off, DotPosition.on],
                            outputRange: ['rgba(255, 255, 255, 0)', color.primary.solid]
                        }),
                        borderColor: left.interpolate({
                            inputRange: [DotPosition.off, DotPosition.on],
                            outputRange: [color.invert2.p42, color.primary.solid]
                        })
                    },
                    hovered ? (value ? styles.hover__selected : styles.hover) : null
                ] },
                React.createElement(Animated.View, { style: [
                        styles.dot,
                        {
                            left,
                            width,
                            backgroundColor: left.interpolate({
                                inputRange: [DotPosition.off, DotPosition.on],
                                outputRange: [color.invert2.p68, color.white.p100]
                            })
                        }
                    ] }),
                icon ? (React.createElement(View, { style: styles.icon },
                    React.createElement(Icon, { name: icon, size: 10, color: value ? color.primary.solid : color.invert2.p26 }))) : null))),
            after ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.after }, after)) : null)));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        width: 40,
        height: size.J,
        borderRadius: 9999
    },
    wrapper: { flexDirection: 'row', alignItems: 'center' },
    main: {
        width: '100%',
        height: '100%',
        borderRadius: 9999,
        borderWidth: 1
    },
    main__icon: {
        flexDirection: 'row-reverse',
        alignItems: 'center'
    },
    icon: {
        marginRight: 4.5,
        zIndex: 9
    },
    hover: {
        backgroundColor: color.invert2.p10
    },
    hover__selected: {
        backgroundColor: color.primary.solidHover
    },
    dot: {
        height: size.F,
        borderRadius: 9999,
        position: 'absolute',
        top: size.B - 1
    },
    header: { marginBottom: size.F },
    header__start: { alignSelf: 'flex-end' },
    after: { marginLeft: size.D },
    before: { marginRight: size.D }
}));
//# sourceMappingURL=index.js.map